/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AllPhasesDropdown_phases$ref: FragmentReference;
declare export opaque type AllPhasesDropdown_phases$fragmentType: AllPhasesDropdown_phases$ref;
export type AllPhasesDropdown_phases = $ReadOnlyArray<{|
  +node: ?{|
    +id: string,
    +name: ?string,
    +projectId: ?string,
  |},
  +$refType: AllPhasesDropdown_phases$ref,
|}>;
export type AllPhasesDropdown_phases$data = AllPhasesDropdown_phases;
export type AllPhasesDropdown_phases$key = $ReadOnlyArray<{
  +$data?: AllPhasesDropdown_phases$data,
  +$fragmentRefs: AllPhasesDropdown_phases$ref,
  ...
}>;
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "AllPhasesDropdown_phases",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PhaseType",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PhaseTypeEdge"
};
// prettier-ignore
(node/*: any*/).hash = '3395666153959a186fca1718aeed5341';

module.exports = node;
